
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnItemsGrid extends Serenity.EntityGrid<CertificationReturnItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationReturnItems'; }
        protected getDialogType() { return CertificationReturnItemsDialog; }
        protected getIdProperty() { return CertificationReturnItemsRow.idProperty; }
        protected getInsertPermission() { return CertificationReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationReturnItemsRow.localTextPrefix; }
        protected getService() { return CertificationReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}